module.exports = __webpack_public_path__ + "img/pic_bk.7abdbd66.png";